import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";

export function setLineClamp(lineClamp: number, lineHeight: string): SerializedStyles {
  return css`
    position: relative;

    display: -webkit-box;

    max-block-size: calc(${lineClamp} * ${lineHeight});

    line-height: ${lineHeight};
    text-overflow: ellipsis;

    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${lineClamp};
  `;
}
